import { getJsToken } from "./tokenGetters";
export default function resolveStylePropValue(props) {
    const { config, tokens, getToken = getJsToken } = props;
    // Booleans aren't valid CSS and React drops them from style
    const value = typeof props.value === "boolean" ? String(props.value) : props.value;
    const { strategy = "hybrid", category, attribute, valueMap } = config;
    if (strategy === "raw") {
        // If a valueMap exists, check if our current value needs translation
        if (valueMap && value in valueMap) {
            const mappedValue = valueMap[value];
            // Only return if it's not undefined (allows for stripping props via mapping to undefined)
            return mappedValue !== undefined
                ? mappedValue
                : undefined;
        }
        return value;
    }
    // 1. Get hybrid fallback
    const hybridFallback = strategy === "hybrid" ? value : undefined;
    // 2. Get semantic values
    const semPath = attribute
        ? [category, attribute, ...String(value).split(".")]
        : [category, ...String(value).split(".")];
    const semResult = getToken(semPath, hybridFallback, tokens);
    // 3. Try the full path first then fallback on the rest (e.g.: button.primary.bg.hover)
    const fullPath = getToken(String(value).split("."), semResult, tokens);
    if (fullPath !== undefined)
        return fullPath;
    // 3. Fallback for Hybrid (e.g.: "10px" or "#FFF")
    return hybridFallback;
}
//# sourceMappingURL=resolveStylePropValue.js.map